const base = require('./base')
const jssdk = {
  signature:base.base.PHPPath+'itofficialaccount/jssdk/signature'
}
module.exports={
  jssdk:jssdk
}


// WEBPACK FOOTER //
// ./src/api/JSSDK.js